var App;

App = require('config/app');

module.exports = App.DocumentController = Ember.ObjectController.extend({
  isCreating: false
});
